import { nanoid } from "@reduxjs/toolkit";

export const uuid = (): string => nanoid();
